/// <reference path="../../typings/index.d.ts" />

module monitoringApp.common {
    export function SuiteFilter() {
        return (runSuites: entities.IRunSuite[], status: string): entities.IRunSuite[] => {

            if (!status || status === "all") { return runSuites; }
            if (status === "passed") {
                return runSuites.filter((suite) => {
                    return suite.failed === 0;
                })
            }
            if (status === "failed") {
                return runSuites.filter((suite) => {
                   return suite.failed > 0;
                })
            }

            return [];
        }
    }
    angular.module("ultimateMonitoringApp").filter("suiteFilter", SuiteFilter);

}
